import { Component, computed, inject, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  MessageBarStore,
  Modal,
  ResolvableModal,
  SOFTLINE_FEATURE_MESSAGE_BAR } from '@softline/ui-core';
import { Store } from '@softline/core';
import { WorkNote } from '../../data/work-note';
import {
  SOFTLINE_FEATURE_WORK_NOTE_BEWEGUNGEN,
  WorkNoteBewegungenStore } from '../../arbeitsschein.shared';
import { Bewegung } from '../../data/bewegung';
import { RichTextEditorComponent } from '@softapps/core/rich-text';

import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'lib-note-dialog',
  templateUrl: './note-dialog.component.html',
  styleUrls: ['./note-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RichTextEditorComponent,
    TranslatePipe] })
export class NoteDialogComponent extends ResolvableModal<null> {
  private store = inject(Store);
  isSaving = false;

  workNote = input.required<WorkNote>();
  bewegung = input.required<Bewegung>();

  readonly editorContent = computed(() => {
    const bemerkung = this.bewegung()?.bemerkung;

    if (!bemerkung) return '';

    const lines = bemerkung.split('<br>');

    let finalString = '';

    for (const line of lines) {
      finalString += `<p>${line}</p>`;
    }

    return finalString.startsWith('<p>') && finalString.endsWith('</p>')
      ? finalString
      : `<p>${finalString}</p>`;
  });

  constructor() {
    super();
  }

  async save(bemerkung: string): Promise<void> {
    try {
      this.isSaving = true;
      const result = await this.saveNote(bemerkung);
      this.isSaving = false;

      if (!result) {
        await this.showSaveError();
        return;
      }

      await this.showSaveSuccess();
      this.resolve(null);
    } catch (e) {
      console.log(e);
      this.isSaving = false;
      await this.showSaveError();
    }
  }

  private async showSaveError(): Promise<void> {
    await this.store.dispatch(
      SOFTLINE_FEATURE_MESSAGE_BAR,
      MessageBarStore.actions.error,
      {
        title: 'Fehler',
        duration: 60000,
        message: 'Beim Speichern der Bemerkung ist ein Fehler aufgetreten!' }
    );
  }

  private async showSaveSuccess(): Promise<void> {
    await this.store.dispatch(
      SOFTLINE_FEATURE_MESSAGE_BAR,
      MessageBarStore.actions.success,
      {
        title: 'Bemerkung gespeichert',
        message: 'Die Bemerkung wurde erfolgreich gespeichert!' }
    );
  }

  private async saveNote(bemerkung: string): Promise<Bewegung | undefined> {
    console.log('start:', bemerkung);

    // This prevents replacing empty rows with <br> since quill adds an empty <p><br></p> automatically
    bemerkung = bemerkung.replace(/<p><br><\/p>/g, '');
    console.log('replace empty rows:', bemerkung);

    bemerkung = bemerkung.replace(/<p\b[^>]*>/gi, '');
    console.log('replace <p>:', bemerkung);

    bemerkung = bemerkung.replace(/<\/p>/gi, '<br>');
    console.log('replace </p>:', bemerkung);

    return await this.store.dispatch(
      SOFTLINE_FEATURE_WORK_NOTE_BEWEGUNGEN,
      WorkNoteBewegungenStore.actions.addNote,
      { entity: { ...this.bewegung(), bemerkung: bemerkung }, id: this.workNote().id }
    );
  }
}
